import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { TemplateApiService } from 'src/api/template'
import { AuthApiService } from 'src/api/auth'
import { environment } from 'src/environments/environment'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { loadTemplates, loadTemplatesFailure, loadTemplatesSuccess } from './template.actions'

@Injectable()
export class TemplateEffects {
  private actions$ = inject(Actions)
  private TemplateApi = inject(TemplateApiService)
  private AuthApi = inject(AuthApiService)
  private toaster = inject(ToasterService)


  loadTemplates$ = createEffect(() => this.actions$.pipe(
    ofType(loadTemplates),
    switchMap(() => {
      const account = this.AuthApi.currentUser?.account || environment.tradecafeAccount
      return from(this.TemplateApi.list(account, {limit: Number.MAX_SAFE_INTEGER})).pipe(
        map(({data}: {data: []}) => loadTemplatesSuccess({ templates: data })),
        catchAndLog(this.toaster, 'Unable to fetch templates', loadTemplatesFailure))
    })))
}
